
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Package, Plus } from 'lucide-react';

export function EmptySubscriptions() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Package className="h-5 w-5" />
          No Active Subscriptions
        </CardTitle>
      </CardHeader>
      <CardContent className="text-center py-8">
        <div className="space-y-4">
          <p className="text-gray-600">
            You don't have any active subscriptions yet.
          </p>
          <p className="text-sm text-gray-500">
            Create your first bin washing subscription to get started.
          </p>
          <Button asChild className="mt-4">
            <a href="/subscriptions">
              <Plus className="h-4 w-4 mr-2" />
              Create First Subscription
            </a>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
